import { provideChameleonDesignSystem } from '../provideChameleonDesignSystem';
import { chameleonToolbar } from './Toolbar.definition';
import { chameleonToolbarButton } from './ToolbarButton/ToolbarButton.definition';
export function registerCustom(prefix, node) {
    return provideChameleonDesignSystem({ prefix, node }).register(chameleonToolbar({ prefix }), chameleonToolbarButton({ prefix }));
}
